import type { SubjectPayload } from '@Application/Subjects/Actions/subjectFetched';

export type SubjectUpdatedAction = {
	type: 'SUBJECT_UPDATED';
	payload: SubjectPayload;
};

export default (payload: SubjectPayload): SubjectUpdatedAction => ({
	type: 'SUBJECT_UPDATED',
	payload,
});
